__turbopack_context__.v({
  "author": "quote-module-scss-module__1InMkG__author",
  "fill-currentColor": "quote-module-scss-module__1InMkG__fill-currentColor",
  "fill-step-almost-black": "quote-module-scss-module__1InMkG__fill-step-almost-black",
  "fill-step-amethyst": "quote-module-scss-module__1InMkG__fill-step-amethyst",
  "fill-step-before-midnight": "quote-module-scss-module__1InMkG__fill-step-before-midnight",
  "fill-step-black": "quote-module-scss-module__1InMkG__fill-step-black",
  "fill-step-black-v2": "quote-module-scss-module__1InMkG__fill-step-black-v2",
  "fill-step-coal-mine-canary": "quote-module-scss-module__1InMkG__fill-step-coal-mine-canary",
  "fill-step-coal-mine-canary-down": "quote-module-scss-module__1InMkG__fill-step-coal-mine-canary-down",
  "fill-step-cold-steel": "quote-module-scss-module__1InMkG__fill-step-cold-steel",
  "fill-step-cyanora": "quote-module-scss-module__1InMkG__fill-step-cyanora",
  "fill-step-cyanora-down": "quote-module-scss-module__1InMkG__fill-step-cyanora-down",
  "fill-step-dark-gray": "quote-module-scss-module__1InMkG__fill-step-dark-gray",
  "fill-step-dark-text": "quote-module-scss-module__1InMkG__fill-step-dark-text",
  "fill-step-diagonal-gradient-midnight-haze-to-black": "quote-module-scss-module__1InMkG__fill-step-diagonal-gradient-midnight-haze-to-black",
  "fill-step-future-fuscia": "quote-module-scss-module__1InMkG__fill-step-future-fuscia",
  "fill-step-future-fuscia-down": "quote-module-scss-module__1InMkG__fill-step-future-fuscia-down",
  "fill-step-light-text": "quote-module-scss-module__1InMkG__fill-step-light-text",
  "fill-step-linear-gradient-cyanora-to-future-fuscia": "quote-module-scss-module__1InMkG__fill-step-linear-gradient-cyanora-to-future-fuscia",
  "fill-step-midnight": "quote-module-scss-module__1InMkG__fill-step-midnight",
  "fill-step-negative": "quote-module-scss-module__1InMkG__fill-step-negative",
  "fill-step-off-white": "quote-module-scss-module__1InMkG__fill-step-off-white",
  "fill-step-positive": "quote-module-scss-module__1InMkG__fill-step-positive",
  "fill-step-right-before-black": "quote-module-scss-module__1InMkG__fill-step-right-before-black",
  "fill-step-right-before-midnight": "quote-module-scss-module__1InMkG__fill-step-right-before-midnight",
  "fill-step-secondary-text": "quote-module-scss-module__1InMkG__fill-step-secondary-text",
  "fill-step-vertical-gradient-cyanora-to-future-fuscia": "quote-module-scss-module__1InMkG__fill-step-vertical-gradient-cyanora-to-future-fuscia",
  "fill-step-warning": "quote-module-scss-module__1InMkG__fill-step-warning",
  "fill-step-white": "quote-module-scss-module__1InMkG__fill-step-white",
  "icon": "quote-module-scss-module__1InMkG__icon",
  "left": "quote-module-scss-module__1InMkG__left",
  "quote": "quote-module-scss-module__1InMkG__quote",
  "right": "quote-module-scss-module__1InMkG__right",
  "step-almost-black": "quote-module-scss-module__1InMkG__step-almost-black",
  "step-amethyst": "quote-module-scss-module__1InMkG__step-amethyst",
  "step-before-midnight": "quote-module-scss-module__1InMkG__step-before-midnight",
  "step-black": "quote-module-scss-module__1InMkG__step-black",
  "step-black-v2": "quote-module-scss-module__1InMkG__step-black-v2",
  "step-coal-mine-canary": "quote-module-scss-module__1InMkG__step-coal-mine-canary",
  "step-coal-mine-canary-down": "quote-module-scss-module__1InMkG__step-coal-mine-canary-down",
  "step-cold-steel": "quote-module-scss-module__1InMkG__step-cold-steel",
  "step-cyanora": "quote-module-scss-module__1InMkG__step-cyanora",
  "step-cyanora-down": "quote-module-scss-module__1InMkG__step-cyanora-down",
  "step-dark-gray": "quote-module-scss-module__1InMkG__step-dark-gray",
  "step-dark-text": "quote-module-scss-module__1InMkG__step-dark-text",
  "step-diagonal-gradient-midnight-haze-to-black": "quote-module-scss-module__1InMkG__step-diagonal-gradient-midnight-haze-to-black",
  "step-future-fuscia": "quote-module-scss-module__1InMkG__step-future-fuscia",
  "step-future-fuscia-down": "quote-module-scss-module__1InMkG__step-future-fuscia-down",
  "step-light-text": "quote-module-scss-module__1InMkG__step-light-text",
  "step-linear-gradient-cyanora-to-future-fuscia": "quote-module-scss-module__1InMkG__step-linear-gradient-cyanora-to-future-fuscia",
  "step-midnight": "quote-module-scss-module__1InMkG__step-midnight",
  "step-negative": "quote-module-scss-module__1InMkG__step-negative",
  "step-off-white": "quote-module-scss-module__1InMkG__step-off-white",
  "step-positive": "quote-module-scss-module__1InMkG__step-positive",
  "step-right-before-black": "quote-module-scss-module__1InMkG__step-right-before-black",
  "step-right-before-midnight": "quote-module-scss-module__1InMkG__step-right-before-midnight",
  "step-secondary-text": "quote-module-scss-module__1InMkG__step-secondary-text",
  "step-vertical-gradient-cyanora-to-future-fuscia": "quote-module-scss-module__1InMkG__step-vertical-gradient-cyanora-to-future-fuscia",
  "step-warning": "quote-module-scss-module__1InMkG__step-warning",
  "step-white": "quote-module-scss-module__1InMkG__step-white",
  "text": "quote-module-scss-module__1InMkG__text",
  "text-left": "quote-module-scss-module__1InMkG__text-left",
  "text-right": "quote-module-scss-module__1InMkG__text-right",
  "text-with-avatar": "quote-module-scss-module__1InMkG__text-with-avatar",
});
